import { logout } from "@/services/common";
import { editPassword } from "@/services/system/user";
import { useModel } from "@@/exports";
import { ModalForm, ProFormText } from "@ant-design/pro-components";
import { message } from "antd";
import { flushSync } from "react-dom";

export default function ResetPassword({
    visible,
    onClose,
}: {
    visible: boolean;
    onClose: () => void;
}) {
    const { initialState, setInitialState } = useModel("@@initialState");

    return (
        <ModalForm
            title="修改密码"
            open={visible}
            modalProps={{
                destroyOnHidden: true,
                maskClosable: false,
                onCancel: onClose,
            }}
            onFinish={async (values) => {
                const { oldPassword, newPassword, confirmPassword } = values;
                if (newPassword !== confirmPassword) {
                    message.error("两次输入密码不一致");
                    return false;
                }
                const res = await editPassword({
                    oldPassword,
                    newPassword,
                });

                if (res.code === 200) {
                    message.success(res.msg);
                    flushSync(() => {
                        setInitialState((s) => ({
                            ...s,
                            currentUser: undefined,
                        }));
                    });
                    logout();
                    return true;
                } else {
                    message.error(res.msg || "修改失败");
                    return false;
                }
            }}
        >
            <ProFormText.Password
                name="oldPassword"
                label="原密码"
                placeholder="请输入原密码"
                rules={[{ required: true, message: "请输入原密码" }]}
            />

            <ProFormText.Password
                name="newPassword"
                label="新密码"
                placeholder="请输入新密码"
                rules={[
                    { required: true, message: "请输入新密码" },
                    {
                        pattern:
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z0-9\S]{8,20}$/,
                        message: "密码要求为8-20个字符，需包含大小写字母和数字",
                    },
                ]}
            />

            <ProFormText.Password
                name="confirmPassword"
                label="确认新密码"
                placeholder="请再次输入新密码"
                dependencies={["newPassword"]}
                rules={[
                    { required: true, message: "请再次输入新密码" },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (
                                !value ||
                                getFieldValue("newPassword") === value
                            ) {
                                return Promise.resolve();
                            }
                            return Promise.reject("两次输入密码不一致");
                        },
                    }),
                ]}
            />
        </ModalForm>
    );
}
